import {_state} from "./../state/state.js";

/**
 * Legal page sticky "Table of contents": smooth-scroll to a section on click
 * (with a fixed-header offset) and highlight the section currently in view.
 *
 * The links are rendered server-side from the content's <h2> headings, so this
 * only wires behaviour. Owns its own click handler (and marks the links
 * `js-handled`) so the global anchor handler doesn't double-bind them.
 */
export const legalToc = () => new Promise((resolve) => {
	const root = document.querySelector('[data-legal]');
	const nav = root && root.querySelector('[data-legal-toc]');
	if (!nav) {
		resolve(true);
		return;
	}

	const links = [...nav.querySelectorAll('[data-toc-link]')];
	const sections = links
		.map((l) => document.getElementById((l.getAttribute('href') || '').slice(1)))
		.filter(Boolean);

	if (!links.length || !sections.length) {
		resolve(true);
		return;
	}

	const headerEl = document.querySelector('#header');
	const offset = () => (headerEl ? headerEl.getBoundingClientRect().height : 0) + 24;

	links.forEach((link) => {
		link.classList.add('js-handled');
		link.addEventListener('click', (e) => {
			const target = document.getElementById((link.getAttribute('href') || '').slice(1));
			if (!target) return;
			e.preventDefault();
			const top = target.getBoundingClientRect().top + window.scrollY - offset();
			if (_state.lenisInit) {
				_state.lenisInit.scrollTo(top, {duration: 0.8});
			} else {
				window.scrollTo({top, behavior: 'smooth'});
			}
			history.replaceState(null, '', link.getAttribute('href'));
		});
	});

	const setActive = (id) => links.forEach((l) =>
		l.classList.toggle('is-active', l.getAttribute('href') === '#' + id));

	let ticking = false;
	const update = () => {
		ticking = false;
		const line = offset() + 8;
		let current = sections[0].id;
		for (const sec of sections) {
			if (sec.getBoundingClientRect().top <= line) current = sec.id;
			else break;
		}
		// Snap to the last item once the page is scrolled to the bottom.
		if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 2) {
			current = sections[sections.length - 1].id;
		}
		setActive(current);
	};
	const onScroll = () => {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	};

	update();
	window.addEventListener('scroll', onScroll, {passive: true});
	window.addEventListener('resize', onScroll, {passive: true});

	resolve(true);
});
